import { Link } from "react-router";
import ZelfVarenBreda from "../assets/images/zelf_varen_breda.svg?react";
import Progress from "./Progress";

export default function Header({
  showProgress = true,
}: {
  showProgress?: boolean;
}) {
  return (
    <header>
      {/* Desktop */}
      <div className="hidden sm:block bg-white shadow-lg/4 p-4">
        <div className="container flex justify-between items-center">
          <Link to="/"><ZelfVarenBreda className="w-26 h-26 -mb-8" /></Link>
          {showProgress && <Progress />}
          <div className="w-26" />
        </div>
      </div>

      {/* Mobile */}
      <div className="sm:hidden">
        <div className="bg-white shadow-lg/4 flex justify-center">
          <Link to="/"><ZelfVarenBreda className="w-24 h-24 translate-y-3 z-10 relative" /></Link>
        </div>
        {showProgress && (
          <div className="bg-border/45 py-5 flex justify-center">
            <Progress />
          </div>
        )}
      </div>
    </header>
  );
}
